'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlurallThumbnail = function (_React$PureComponent) {
  _inherits(PlurallThumbnail, _React$PureComponent);

  function PlurallThumbnail() {
    _classCallCheck(this, PlurallThumbnail);

    return _possibleConstructorReturn(this, (PlurallThumbnail.__proto__ || Object.getPrototypeOf(PlurallThumbnail)).apply(this, arguments));
  }

  _createClass(PlurallThumbnail, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          borderRadius = _props.borderRadius,
          size = _props.size,
          backgroundColor = _props.backgroundColor;

      return _react2.default.createElement(
        'svg',
        {
          width: size,
          height: size,
          viewBox: '0 0 44 44',
          style: {
            background: '' + backgroundColor,
            borderRadius: '' + borderRadius
          }
        },
        _react2.default.createElement(
          'g',
          { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
          _react2.default.createElement(
            'g',
            { fill: '#FFFFFF' },
            _react2.default.createElement('path', { d: 'M21.9998211,33.9716479 C15.9347165,33.9716479 11,29.054199 11,23.0100425 C11,21.4174677 12.2960114,20.1257285 13.8946521,20.1257285 C15.4932928,20.1257285 16.789662,21.4174677 16.789662,23.0100425 C16.789662,25.8733266 19.1266321,28.2023069 21.9998211,28.2023069 C24.8730102,28.2023069 27.210338,25.8733266 27.210338,23.0100425 C27.210338,21.4174677 28.5063495,20.1257285 30.1053479,20.1257285 C31.7039886,20.1257285 33,21.4174677 33,23.0100425 C33,29.054199 28.0656412,33.9716479 21.9998211,33.9716479' }),
            _react2.default.createElement('path', { d: 'M30.1071061,17.6912524 C29.3548209,17.6912524 28.6180613,17.3874752 28.0870157,16.8586778 C27.5563229,16.3270676 27.2514569,15.5950488 27.2514569,14.8454504 C27.2514569,14.0962035 27.5563229,13.3641848 28.0870157,12.8332778 C28.6180613,12.3041288 29.3548209,12 30.1071061,12 C30.8590384,12 31.5936809,12.3041288 32.1250793,12.8332778 C32.6578892,13.3641848 32.9624023,14.0962035 32.9624023,14.8454504 C32.9624023,15.5950488 32.6578892,16.3270676 32.1250793,16.8586778 C31.5936809,17.3874752 30.8590384,17.6912524 30.1071061,17.6912524' }),
            _react2.default.createElement('path', { d: 'M13.8552963,17.6912524 C13.103364,17.6912524 12.3683686,17.3874752 11.8355588,16.8586778 C11.3045132,16.3270676 11,15.5950488 11,14.8454504 C11,14.0962035 11.3045132,13.3641848 11.8355588,12.8332778 C12.3683686,12.3041288 13.103364,12 13.8552963,12 C14.6072286,12 15.3422239,12.3041288 15.8750338,12.8332778 C16.4060794,13.3641848 16.7109454,14.0962035 16.7109454,14.8454504 C16.7109454,15.5950488 16.4060794,16.3270676 15.8750338,16.8586778 C15.3422239,17.3874752 14.6072286,17.6912524 13.8552963,17.6912524' })
          )
        )
      );
    }
  }]);

  return PlurallThumbnail;
}(_react2.default.PureComponent);

PlurallThumbnail.propTypes = {
  borderRadius: _propTypes2.default.string,
  size: _propTypes2.default.number,
  backgroundColor: _propTypes2.default.string
};

PlurallThumbnail.defaultProps = {
  borderRadius: '10px',
  size: 44,
  backgroundColor: '#655AA3'
};

exports.default = PlurallThumbnail;